import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Select } from "antd";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

import { postData } from "../../utils/service";
import { changeLanguage } from "../../utils/functions";
import {
  URL_API_BANNERS,
  URL_API_NEWS_BY_TEACHER,
  URL_WEB_NEWS,
} from "./../../utils/constants";

import Pagination from "./../../components/pagination";
import CardInformationCommon from "./../../components/CardInformationCommon/index";
import Breadcrumb from "./../../components/BreadcrumbCommon/index";
import BannerCommon from "../../components/BannerCommon";

import "./../../assets/styles/information/information.scss";

const InformationByTeacher = () => {
  const { t } = useTranslation("translation");
  const location = useLocation();

  const beginQuery = location?.search?.split("?")?.[1];
  const [query, setQuery] = useState(beginQuery);

  const [dataInformation, setDataInformation] = useState([]);
  const [imageBanner, setImageBanner] = useState("");
  const [params, setParams] = useState({
    currentPage: 1,
    pageSize: 12,
    total: 0,
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  const [filterInformation, setFilterInformation] = useState({
    keyword: "",
    info_catalog_id: query,
    post_date_from: "",
    post_date_to: "",
    isPostCreatedLate: false,
    isPostCreatedEarly: true,
  });

  const sharedBy = [
    { id: "3", value: "teacher" },
    { id: "4", value: "newBlackBelt" },
    { id: "5", value: "student" },
    { id: "1", value: "orther" },
  ];

  const renderShareBy = (id) => {
    return sharedBy.find((item) => item.id === id)?.value;
  };

  const categoryOption = [
    {
      value: "new",
      label: t("information.newPost"),
    },
    {
      value: "old",
      label: t("information.oldPost"),
    },
  ];

  const handleFilterInformation = (value) => {
    if (value === "new") {
      setFilterInformation({
        ...filterInformation,
        isPostCreatedLate: false,
        isPostCreatedEarly: true,
      });
    } else {
      setFilterInformation({
        ...filterInformation,
        isPostCreatedLate: true,
        isPostCreatedEarly: false,
      });
    }

    setTimeout(() => {
      const gglang = Cookies.get("googtrans");
      changeLanguage(gglang ? gglang.replace("/vi/", "") : "vi");
    }, 500);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/web-news-by") {
      setFilterInformation({
        ...filterInformation,
        info_catalog_id: beginQuery,
      });
      setQuery(beginQuery);
    }
  }, [location?.search]);

  useEffect(() => {
    postData(URL_API_NEWS_BY_TEACHER, {
      per_page: params?.pageSize,
      page: params?.currentPage,
      ...filterInformation,
    })
      .then((res) => {
        const resDatas = res?.data?.data;

        if (
          filterInformation?.isPostCreatedEarly &&
          !filterInformation.isPostCreatedLate
        ) {
          const resData = resDatas?.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
          });
          setDataInformation(resData);
        } else {
          const resData = resDatas?.sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          });
          setDataInformation(resData);
        }
        setParams({ ...params, total: res?.data?.paginate?.total });
      })
      .catch((err) => {
        return err;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.currentPage, filterInformation, query]);

  useEffect(() => {
    postData(URL_API_BANNERS, { is_show: true })
      .then((res) => {
        const imageActivity = res?.data?.data?.find(
          (item) => item.type === "TEACHER_SHARE"
        );
        setImageBanner(
          isMobile ? imageActivity?.image_mobile : imageActivity?.image
        );
      })
      .catch((err) => {
        return err;
      });
  }, []);

  const handleChangeCurrentPage = (e) => {
    setParams({ ...params, currentPage: e });
  };

  return (
    <>
      <div className="information">
        <div className="information__banner">
          <BannerCommon
            img={imageBanner}
            text1={t(`information.${renderShareBy(query)}`)}
          />
        </div>
        <div className="container">
          <div className="container__breadcrumb">
            <Breadcrumb
              dataBreadcrumb={[
                { title: t("information.home"), url: "/" },
                {
                  title: t(`information.${renderShareBy(query)}`),
                },
              ]}
            />
          </div>
          <div className="container__content">
            <div className="container__select">
              <Select
                placeholder={t("information.placeholder")}
                options={categoryOption}
                onChange={handleFilterInformation}
                className="library-filter-wrap"
              />
            </div>

            <Row
              gutter={[{ xs: 8, lg: 16, sm: 16, xl: 24, md: 16, xxl: 24 }, 24]}
            >
              {dataInformation?.length > 0 &&
                dataInformation?.map((item) => {
                  return (
                    <Col xs={24} md={12} lg={8} xl={6} key={item?.id}>
                      <CardInformationCommon
                        data={{
                          image:
                            item?.thumbnail ||
                            item?.image ||
                            item?.attach_files?.[0],
                          title: item?.title,
                          description: item?.description,
                          id: item?.id,
                          date: item?.created_at,
                          path: URL_WEB_NEWS,
                        }}
                      />
                    </Col>
                  );
                })}
            </Row>
          </div>
          <div className="container__pagination">
            <Pagination
              current={params?.currentPage}
              pageSize={params?.pageSize}
              total={params?.total}
              onChange={handleChangeCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default InformationByTeacher;
